export default __webpack_public_path__ + "static/media/roomFive.3950e9af.jpg";